// eslint-disable-next-line func-names
(function ($) {
  var Flatpickr = (function () {

    const flatpickrInit = () => {
      $('[data-drupal-selector="edit-start"], [data-drupal-selector="edit-end"]').flatpickr({
        locale: "et",
        altInput: true,
        altFormat: "d.m.Y",
        disableMobile: "true",
        monthSelectorType: "static",
        parseDate: (datestr, format) => {
          if (datestr === "now") {
            return moment().toDate();
          }
          if (datestr === "+365 days") {
            return moment().add(1, 'y').toDate();
          }
          return moment(datestr, "YYYY-M-DD").toDate();
        },
      });
    }

    return {
      init: () => {
        flatpickrInit();
      }
    };
  })();

  Flatpickr.init();
})
(jQuery);
